import { useEffect, useRef } from "react"
import { Link, useLocation, useNavigate, useOutletContext, useSearchParams } from "react-router-dom"
import Filter from "pages/purchase/filter"
import nProgress from "nprogress"
import { useAuth } from "contexts/auth-context"
import { Pagination, Transition } from "components"
import { lang } from "config"
import { Pencil, Plus } from "components/icons/outline"
import { useResultSet } from "repositories/db-repository"
import Delete from "./delete"
import Refresh from "./refresh"
import { getBranchList } from "helpers/general-helper"

export default function List() {
    // Logged in user ability
    const { user, can, currentBranch } = useAuth()
    // Configuration
    // const { configuration } = usePage()

    // Transition
    const { title, transition, setTransition } = useOutletContext()

    // React router navigate hook
    const navigate = useNavigate()

    // React router location hook
    const location = useLocation()

    // Query parameters
    const [searchParams, setSearchParams] = useSearchParams()

    const searchInput = useRef()

    const page = searchParams.get('page')
    const search = searchParams.get('search')
    const status = searchParams.get('status')

    const branchSelection = getBranchList()
    const branch_id_list = () => {
        var tmp_branch_id_list = []

        if (branchSelection) {
            branchSelection.forEach(item => {
                tmp_branch_id_list.push(item.id)
            });
            return tmp_branch_id_list
        } else {
            return
        }
    }
    const { data: result_set, isLoading, mutate } = useResultSet(`${process.env.REACT_APP_REMAX_PS_API_URL}`, `purchase_transaction`, {
        outlet_id: currentBranch?.id,
        branch_list: JSON.stringify(branch_id_list()),
        page,
        record_per_page: 5, 
        search,
        latest_flow_detail_id: status
    })

    const { data: list_flow } = useResultSet(`${process.env.REACT_APP_REMAX_PS_API_URL}`, `list_flow`, {
        
    })

    useEffect(() => {
        
        window.history.replaceState({}, document.title)

        if (transition.reverse) {
            setTransition({ type: 'slide', reverse: false })
        }
    }, [])

    useEffect(() => {
        searchInput.current.focus()
    }, [search])

    useEffect(() => {
        if (search === "") {
            navigate(``, { replace: true })
        }

        if (isLoading) {
            nProgress.start()
        } else {
            nProgress.done()
        }

    }, [result_set, isLoading])

    // Data filter handlers
    const updateFilter = (value) => {
        setSearchParams(value)
    }

    const removeFilter = () => {
        setSearchParams({})
    }

    const generatePaginationParam = () => {
        var tmp = ''

        if (status) {
            tmp += `&status=${status}`
        }

        if (searchParams.has('search')) {
            var tmp_search = searchParams.get('search')
            tmp += `&search=${tmp_search}`
        }
        console.log('params pagination ' + tmp)
        return tmp
    }

    return (
        <Transition type="fade">
            <div className="pb-4 space-y-6 lg:pb-8">
                <div className="flex items-center justify-between text-xs">
                    <div className="flex items-center sm:space-x-2">
                        <div className="relative hidden sm:block">
                            <div className="absolute inset-y-0 flex items-center pl-3 pointer-events-none">
                                <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" width={24} height={24} viewBox="0 0 24 24" strokeWidth={1} stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                    <circle cx={10} cy={10} r={7}></circle>
                                    <line x1={21} y1={21} x2={15} y2={15}></line>
                                </svg>
                            </div>
                            <input ref={searchInput} onChange={(e) => setSearchParams({ search: e.target.value })} value={search} type="text" placeholder={`${lang.search} Purchase`} autoComplete="off" className="w-64 py-3 pl-8 pr-4 text-xs transition border border-neutral-200 focus:outline-none rounded-xl focus:border-neutral-400 focus:ring focus:ring-neutral-200" />
                        </div>
                        <Filter list_flow={list_flow} onSubmit={updateFilter} onRemove={removeFilter} data={Object.fromEntries(Object.entries({ status }).filter(([_, v]) => v != null))} />
                    </div>
                    <div className="flex items-center space-x-2">
                        {can('purchase.create') && (
                            <div>
                                <Link to="create" onClick={() => { setTransition({ type: 'slide', reverse: true }) }} state={{ back: title, from: location?.pathname, transition: { type: 'slide' } }} className="inline-flex items-center px-4 py-3 space-x-2 text-white transition bg-neutral-800 rounded-xl active:hover:scale-90">
                                    <Plus className="w-4 h-4" stroke={1.5} />
                                    <span>{lang.create}</span>
                                </Link>
                            </div>
                        )}
                    </div>
                </div>
                <div className="overflow-x-auto border border-neutral-200 rounded-xl">
                    <table className="min-w-full overflow-x-auto divide-y divide-neutral-200">
                        <thead className="bg-neutral-50 rounded-t-3xl">
                            <tr>
                                {result_set?.header?.length > 0 && result_set?.header?.map((row, index) => (
                                    (index === 1 || index === 3 || index === 5 || index === 6 || index === 7 || index === 8 ) && (
                                        <th scope="col" className="px-1 py-3 text-xs font-medium text-left uppercase text-neutral-500 whitespace-nowrap">{row}</th>
                                    )
                                ))}
                                {result_set?.header?.length > 0 && (
                                    <th scope="col" className="relative px-1 py-3"><span className="sr-only">{lang.action}</span></th> 
                                )}
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-neutral-200">
                            {/* When loading */}
                            {isLoading && (
                                <tr className="text-center">
                                    <td colSpan="10" className="px-1 py-4 text-xs text-neutral-500 whitespace-nowrap">
                                        {lang.loading_data}
                                    </td>
                                </tr>
                            )}

                            {/* When there are no list available */}
                            {result_set?.data?.length === 0 && !search && !isLoading && (
                                <tr className="text-center">
                                    <td colSpan="10" className="px-1 py-4 text-xs text-neutral-500 whitespace-nowrap">
                                        {lang.no_data}
                                    </td>
                                </tr>
                            )}

                            {/* When there are no list available on searching */}
                            {result_set?.data?.length === 0 && search && !isLoading && (
                                <tr className="text-center">
                                    <td colSpan="10" className="px-1 py-4 text-xs text-neutral-500 whitespace-nowrap">
                                        {lang.no_result}
                                    </td>
                                </tr>
                            )}

                            {result_set?.dual?.length > 0 && result_set.dual?.map(row => (
                                <tr>
                                    {row[1]?.length > 0 && row[1]?.map((row_item, index) => (
                                        (index === 1 || index === 3 || index === 5 || index === 6 || index === 7 || index === 8 ) && (
                                            <td className="px-1 py-4 text-xs font-medium text-neutral-900 whitespace-nowrap">
                                                {String(row_item ?? '').length > 50 ? String(row_item ?? '').substring(0, 50).concat('...') : String(row_item ?? '')}
                                            </td>
                                        ) 
                                    ))}
                                    
                                    <td className="px-1 py-4 text-xs font-medium text-right whitespace-nowrap">
                                        <div className="inline-flex items-center space-x-2">
                                            {(can('purchase.edit') || can('purchase.approve') || can('purchase.send')) && (
                                            <div className="space-x-2">
                                                <Link to={`${row[0].id}/edit`} state={{ back: title, from: location?.pathname, transition: 'slide' }} className="inline-flex items-center p-1 text-white transition rounded-full bg-neutral-800 active:hover:scale-90">
                                                    <Pencil className="w-6 h-6" />
                                                </Link>
                                                {/* <Refresh data={row[0]} onSuccess={mutate}/> */}
                                            </div>
                                            )}
                                            {(can('purchase.delete')) && (
                                            <Delete data={row[0]} onSuccess={mutate}/>)}
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <Pagination params={generatePaginationParam()} links={result_set?.links} from={result_set?.from} to={result_set?.to} total={result_set?.total} />
            </div>
        </Transition>
    )
}